// =============================================================================
// ZaplanowanaZmianaPlanu — „Zmiana na X od <data>" + przycisk „Odwołaj zmianę"
// na karcie modułu (`ModulesPage`) i abonamentu (`BillingPage`).
//
// Jeden komponent w obu miejscach (runda 5): dotąd każda strona wpisywała
// zdanie po swojemu, a test mierzył wyłącznie czystą funkcję — usunięcie JSX
// z karty przechodziło CI. Odwołanie miało jedyną drogę przez „wybór obecnego
// planu", którego panel nie pozwalał kliknąć; teraz to przycisk tuż przy
// zdaniu, który woła `POST /api/billing/cancel-scheduled-change`.
// =============================================================================

import { Loader2, Undo2 } from 'lucide-react';

import {
  zdanieZaplanowanejZmiany,
  type OpcjeZdania,
  type WierszZeZmiana,
} from '../../lib/zaplanowanaZmiana';

export interface ZaplanowanaZmianaPlanuProps {
  wiersz: WierszZeZmiana | null | undefined;
  /** Nazwa pakietu z cennika — bez niej zdanie bierze nazwę zapasową. */
  nazwa?: OpcjeZdania['nazwa'];
  /** Odwołanie zmiany; bez niego zdanie bez przycisku. */
  onOdwolaj?: () => void;
  odwolywanie?: boolean;
  className?: string;
}

export function ZaplanowanaZmianaPlanu({
  wiersz,
  nazwa,
  onOdwolaj,
  odwolywanie = false,
  className = '',
}: ZaplanowanaZmianaPlanuProps) {
  const zdanie = zdanieZaplanowanejZmiany(wiersz, { nazwa });
  if (!zdanie) return null;
  return (
    <div
      data-testid="zaplanowana-zmiana-planu"
      className={`flex flex-wrap items-center gap-2 ${className}`}
    >
      <p className="text-[11px] text-amber-400/80">{zdanie}</p>
      {onOdwolaj && (
        <button
          type="button"
          onClick={onOdwolaj}
          disabled={odwolywanie}
          className="flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium text-amber-300 hover:text-amber-200 bg-amber-500/10 hover:bg-amber-500/20 rounded-ids-md transition-colors disabled:opacity-50"
        >
          {odwolywanie ? (
            <Loader2 className="w-3 h-3 animate-spin" />
          ) : (
            <Undo2 className="w-3 h-3" />
          )}
          Odwołaj zmianę
        </button>
      )}
    </div>
  );
}
